// src/components/admin/page-sections/StaticContentSection.js
import React, { useRef, useEffect } from 'react';
import LazyImage from '../../LazyImage';

const StaticContentSection = ({ content }) => {
  const {
    title = 'Discover Our Unique Packaging Solutions',
    description = 'Experience creativity and innovation in every design. Our custom packaging solutions are crafted to elevate your brand\'s presence and make a lasting impression.',
    buttonText = 'Learn More',
    buttonLink = '/aboutUs',
    buttonColor = '#2563eb', // blue-600
    buttonTextColor = '#ffffff',
    imageUrl = '/images/logo-static.png',
    imageAlt = 'Packaging',
    imageRadius = '50px',
    imageShadow = true,
    backgroundColor = '#3b82f6', // blue-500
    backgroundGradient = true,
    gradientFrom = '#3b82f6', // blue-500
    gradientTo = '#8b5cf6', // purple-600
    textColor = '#ffffff',
    paddingTop = '2.5rem',
    paddingBottom = '2.5rem',
    paddingLeftDesktop = '40px',
    paddingRightDesktop = '0px',
    reverseOnMobile = false,
    marginTop = '0.5rem',
    marginBottom = '8rem',
    borderRadius = '0.5rem',
    animationEnabled = true,
    animationDelay = '0',
    contentAlignment = 'left',
    imageWidth = '500px'
  } = content;

  const sectionRef = useRef(null);

  // Intersection Observer for animation
  useEffect(() => {
    if (!animationEnabled) return;
    
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          const el = entry.target;
          el.style.transform = 'translateY(0) rotateX(0)';
          el.style.opacity = '1';
          observer.unobserve(el);
        }
      },
      { threshold: 0.2 }
    );
    
    if (sectionRef.current) {
      sectionRef.current.style.transform = 'translateY(40px) rotateX(10deg)';
      sectionRef.current.style.opacity = '0';
      observer.observe(sectionRef.current);
    }
    
    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, [animationEnabled]);

  // Set up background style
  const backgroundStyle = backgroundGradient
    ? { backgroundImage: `linear-gradient(to right, ${gradientFrom}, ${gradientTo})` }
    : { backgroundColor };

  // Set up text alignment classes
  const textAlignClass = contentAlignment === 'center' 
    ? 'text-center' 
    : contentAlignment === 'right' 
      ? 'text-right'
      : 'text-left';

  return (
    <div className="w-full" style={{ marginTop, marginBottom }}>
      <div
        ref={sectionRef}
        className={`text-white rounded-lg shadow-xl flex flex-col ${reverseOnMobile ? 'md:flex-row-reverse' : 'md:flex-row'} items-center`}
        style={{
          ...backgroundStyle,
          borderRadius,
          paddingTop,
          paddingBottom,
          color: textColor,
          transition: 'transform 0.8s ease-out, opacity 0.8s ease-out',
          transitionDelay: animationDelay
        }}
      >
        <div 
          className={`md:w-1/2 lg:px-12 mb-6 md:mb-0 px-6 md:px-10 ${textAlignClass}`}
          style={{
            paddingLeft: `calc(${paddingLeftDesktop} + 2rem)`,
            paddingRight: contentAlignment === 'center' ? `calc(${paddingRightDesktop} + 2rem)` : paddingRightDesktop
          }}
        >
          <h2 className="text-4xl font-bold mb-4">{title}</h2>
          <p className="text-lg pr-4 sm:pr-4">{description}</p>
          {buttonText && (
            <div className="mt-8">
              <button
                onClick={() => window.location.href = buttonLink}
                className="px-6 py-3 rounded-lg font-semibold transition-all duration-300 transform hover:scale-105 shadow-md hover:shadow-lg"
                style={{
                  backgroundColor: buttonColor,
                  color: buttonTextColor
                }}
              >
                {buttonText}
              </button>
            </div>
          )}
        </div>
        <div className={`md:w-1/2 flex justify-center w-full pr-8 pl-8
            // ${reverseOnMobile ? 'pr-0' : 'pl-0'}`
            }
           >
          {imageUrl && (
            <img
              src={imageUrl}
              alt={imageAlt}
              className={`w-auto h-auto ${imageShadow ? 'shadow-lg' : ''}`}
              style={{
                // maxWidth: imageWidth,
                borderTopLeftRadius: imageRadius,
                // marginRight: reverseOnMobile ? '0' : '10px',
                // marginLeft: reverseOnMobile ? '10px' : '0',
              
              }}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default StaticContentSection;